import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Overview")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Any parachain account added in Robonomics subscription by Subscription Owner may interact with smart home in Home Assistant local panel. This is the way to add users to Home assistant without third party servers. Only user can access to all smart home data & services by encrypting it with seed phrase.")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Here you may create or restore Home Assistant password for user added in subscription.")

export function render(_ctx, _cache) {
  const _component_robo_card_label_section = _resolveComponent("robo-card-label-section")
  const _component_robo_card_label = _resolveComponent("robo-card-label")
  const _component_robo_text = _resolveComponent("robo-text")
  const _component_robo_section = _resolveComponent("robo-section")
  const _component_robo_card_section = _resolveComponent("robo-card-section")
  const _component_robo_card = _resolveComponent("robo-card")

  return (_openBlock(), _createBlock(_component_robo_section, null, {
    default: _withCtx(() => [
      _createVNode(_component_robo_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_robo_card_label, null, {
            default: _withCtx(() => [
              _createVNode(_component_robo_card_label_section, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_robo_card_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_robo_section, { offset: "x1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_robo_text, {
                    weight: "normal-italic",
                    offset: "x1",
                    hyphen: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_2
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_robo_text, {
                    weight: "normal-italic",
                    offset: "x1",
                    hyphen: ""
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}